/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';
import videojs from 'video.js';
import SetInterval from 'set-interval';
import { selectSource } from '../../state/clipperMediaContent';
import { updatePlayerReady, updateIsPlaying, updateCurrentTime } from '../../state/videoPlayer';
import { clipperVideoJsOptions } from '../../constants/videoJsOptions';

// Helper to safely call play() and catch autoplay policy errors
const safePlay = (player) => {
  const playPromise = player.play();
  if (playPromise !== undefined) {
    playPromise.catch(() => {
      // Autoplay was prevented - this is expected behavior
    });
  }
};

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    bindMethods(this);
    this.player = null;
  }

  componentDidMount() {
    const {
      updatePlayerReady, timeStamp, videoSource,
    } = this.props;
    this.player = videojs(clipperVideoJsOptions.id, {
      liveui: true,
      controls: true,
      preload: 'metadata',
      controlBar: {
        volumePanel: { inline: false },
      },
      // errorDisplay: false,
      loop: false,
      playbackRates: [0.5, 1, 1.5, 2, 5],
    }, () => {
      this.player.on('error', (e) => {
        console.log('[QA] Error with video player', e);
      });
      this.player.seekButtons({
        forward: 1,
        back: 1,
      });

      this.player.controlBar.on('mousedown', (e) => { e.preventDefault(); });
      if (videoSource) {
        this.player.src({ src: videoSource });
      }
      updatePlayerReady(true);
      this.player.on('timeupdate', this.handleTimeUpdate);
      this.player.on('ratechange', this.handleRateChange);
      this.player.on('pause', this.handlePause);
      this.player.on('play', this.handlePlay);
      this.player.currentTime(timeStamp);
      safePlay(this.player);
    });
  }

  componentDidUpdate() {
    const { videoSource, timeStamp } = this.props;
    if (this.player && videoSource) {
      const currentSource = this.player.src();
      if (!currentSource || videoSource !== currentSource) {
        this.player.src({ src: videoSource });
      }
      if (timeStamp && timeStamp !== 0) this.player.currentTime(timeStamp);
      safePlay(this.player);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleRateChange() {
    SetInterval.clear('rewind');
  }

  handleTimeUpdate() {
    const { updateCurrentTime } = this.props;
    const currentTime = this.player.currentTime();

    updateCurrentTime(currentTime);
  }

  handlePause() {
    const { updateIsPlaying } = this.props;
    const isPlaying = false;
    updateIsPlaying(isPlaying);
    SetInterval.clear('rewind');
  }

  handlePlay() {
    const { updateIsPlaying } = this.props;
    const isPlaying = true;
    updateIsPlaying(isPlaying);
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    return (
      <div
        id="VideoPlayerContainer"
        data-vjs-player
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      >
        <video
          // eslint-disable-next-line no-return-assign
          id={clipperVideoJsOptions.id}
          className="video-js vjs-16-9 vjs-big-play-centered"
        />
      </div>
    );
  }
}

VideoPlayer.propTypes = {
  updatePlayerReady: PropTypes.func.isRequired, // supplied from Redux
  updateIsPlaying: PropTypes.func.isRequired, // supplied from Redux
  updateCurrentTime: PropTypes.func.isRequired, // supplied from Redux
  timeStamp: PropTypes.number, // supplied from Redux
  videoSource: PropTypes.string, // supplied from Redux
};

const mapStateToProps = (state) => ({
  timeStamp: state.clipperMediaContent.timeStamp,
  videoSource: selectSource(state),
});

const mapDispatchToProps = {
  updatePlayerReady,
  updateIsPlaying,
  updateCurrentTime,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoPlayer);
